import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
// components
import GroupRecipients from "./GroupRecipients";
import Button from "../../../../../components/buttons/buttons";
import { Beat } from "../../../../../plugins/spinners.plugin";
import DotMenu from "../../../../../assets/images/icons/dot-menu.svg";
// requests
import {
  showANotifierGroup,
  // closeANotifierGroup,
  deleteANotifierGroup,
} from "../../../../../redux/notifierGroup/notifierGroupAction";

export default function SingleRecipientGroup() {
  let { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [openDropdown, setOpenDropdown] = useState(false);

  // const isMobile = () => /Mobi|Android/i.test(navigator.userAgent);

  const { singleNotifierGroup, deleting } = useSelector(
    (state) => state.notifierGroup
  );

  useEffect(() => {
    window.scrollTo(0, 0);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (id) {
      dispatch(showANotifierGroup(id, page));
    }
    // eslint-disable-next-line
  }, [id, page]);

  const toggleBtn = () => {
    setOpenDropdown(!openDropdown);
  };

  const handleDeleteGroup = async () => {
    const response = await dispatch(deleteANotifierGroup({ id: id }));
    if (response?.status === "success") {
      navigate(-1);
    }
  };
  return (
    <div data-test="singleRestaurant-page">
      <div className="border border-[#E4E4F3] dark:border-none bg-white dark:bg-[#121212] rounded-md py-5 px-8 mb-8">
        <div className="border-b border-[#E4E4F3] py-3 flex justify-between gap-6 items-center">
          <h3 className="text-lg font-medium">{singleNotifierGroup?.title}</h3>
          <div className="relative block sm:hidden">
            <button
              className="flex text-[#717485] gap-1 items-center"
              onClick={toggleBtn}
              type="button"
            >
              <img src={DotMenu} alt="menu" />
            </button>
            {openDropdown && (
              <div className="absolute right-0 z-10 w-[280px] border-[#E4E4F3] bg-white px-0 overflow-y-auto shadow-xl transform transition-all">
                <div className="grid grid-cols-1 gap-4 p-4">
                  <Button.Primary
                    type={"button"}
                    title={deleting ? <Beat /> : "Delete Group"}
                    onClick={handleDeleteGroup}
                  />
                  <Button.Secondary
                    type={"button"}
                    title={"Edit Group"}
                    onClick={() =>
                      navigate(
                        `/admin/settings/broadcast-notification/recipient-groups/edit/${id}`
                      )
                    }
                  />
                </div>
              </div>
            )}
          </div>
          {/* Buttons for web view */}
          <div className="hidden sm:flex gap-4 items-center">
            <Button.Primary
              type={"button"}
              title={deleting ? <Beat /> : "Delete Group"}
              onClick={handleDeleteGroup}
            />
            <Button.Secondary
              type={"button"}
              title={"Edit Group"}
              onClick={() =>
                navigate(
                  `/admin/settings/broadcast-notification/recipient-groups/edit/${id}`
                )
              }
            />
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-5 gap-8 mt-6">
          <div>
            <label className="text-[#9CA3AF] dark:text-[#BCBCBC] text-sm mb-2">
              Name
            </label>
            <p className="text-[#151515] dark:text-white text-sm">
              {singleNotifierGroup?.title}
            </p>
          </div>
          <div>
            <label className="text-[#9CA3AF] dark:text-[#BCBCBC] text-sm mb-2">
              User Count
            </label>
            <p className="text-[#151515] dark:text-white text-sm break-words">
              {singleNotifierGroup?.recipients?.length}
            </p>
          </div>
          <div>
            <label className="text-[#9CA3AF] dark:text-[#BCBCBC] text-sm mb-2">
              Date Created
            </label>
            <p className="text-[#151515] dark:text-white text-sm">
              {moment(singleNotifierGroup?.created_at).format("MMM DD, YYYY")}
            </p>
          </div>
        </div>
      </div>

      {/* Group recipients section */}
      <GroupRecipients page={page} setPage={setPage} />
    </div>
  );
}
